/// <reference path="../_all.ts" />

module glossar {
  'use strict';


  export function firstLetterFilter() {
     return function(input : GlossaryEntry[], letter : string) {
        input = input || [];
        var out = [];
        input.forEach(function (item) {
            //console.log("current item is", item, item.charAt(0));
            if (item.IndexLetter.toLowerCase() == letter.toLowerCase()) {
                out.push(item);
            }
        });
        return out;
     }
  }


}